class SearchBlock {
	constructor() {
		this.searchBlock = document.querySelector('.search');
		this.resultsContainer = null;
		this.resultsAmount = null;
		this.isInitialized = false;

		this.init();
	}

	init() {
		if (!this.searchBlock) {
			console.warn('Search block not found');
			return;
		}

		this.resultsContainer = this.searchBlock.querySelector('.facetwp-template');
		this.resultsAmount = this.searchBlock.querySelector('.search-results-counts');

		if (!this.resultsContainer) {
			console.warn('Search results container not found');
			return;
		}

		this.bindEvents();
		this.checkInitialState();
		this.isInitialized = true;
	}

	bindEvents() {
		document.addEventListener('facetwp-loaded', this.handleFacetwpLoaded.bind(this), { passive: true });
		document.addEventListener('facetwp-refresh', this.handleFacetwpRefresh.bind(this), { passive: true });
	}

	handleFacetwpLoaded() {
		if (!this.isInitialized) return;
		this.toggleResultsVisibility();
	}

	handleFacetwpRefresh() {
		if (!this.isInitialized) return;
		this.hideResults();
	}

	hasFacetValues() {
		if (typeof FWP === 'undefined' || !FWP.facets) {
			return false;
		}

		return Object.values(FWP.facets).some((facet) => (Array.isArray(facet) ? facet.length > 0 : Boolean(facet)));
	}

	toggleResultsVisibility() {
		const hasValues = this.hasFacetValues();

		requestAnimationFrame(() => {
			if (hasValues) {
				this.showResults();
			} else {
				this.hideResults();
			}
		});
	}

	showResults() {
		this.resultsContainer?.classList.remove('hidden');
		this.resultsAmount?.classList.remove('hidden');
	}

	hideResults() {
		this.resultsContainer?.classList.add('hidden');
		this.resultsAmount?.classList.add('hidden');
	}

	checkInitialState() {
		if (typeof FWP !== 'undefined') {
			this.toggleResultsVisibility();
		} else {
			this.waitForFWP();
		}
	}

	waitForFWP(attempts = 0, maxAttempts = 10) {
		if (typeof FWP !== 'undefined') {
			this.toggleResultsVisibility();
			return;
		}

		if (attempts >= maxAttempts) {
			console.warn('FWP object not available after maximum attempts');
			return;
		}

		const delay = Math.min(50 * Math.pow(2, attempts), 1000);
		setTimeout(() => this.waitForFWP(attempts + 1, maxAttempts), delay);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new SearchBlock();
});
